import { z } from "zod";

// isolatedDeclarations: annotate the shape type explicitly so tsc can emit declarations
// without reading across module boundaries. We define the output shape as a TS interface
// and use z.ZodType<Output> on the exported const.

export interface BatchSet {
  recipeId: string;
  mode?: string | undefined;
  batchSize: string;
  fullBatchMultiplier?: number | undefined;
  sourceMode?: string | undefined;
  allowSameAcrossBatches?: boolean | undefined;
  selections?: Record<string, unknown> | undefined;
}

export const BatchSet: z.ZodType<BatchSet> = z.strictObject({
  recipeId: z.string().min(1).max(100),
  mode: z.string().min(1).max(50).optional(),
  batchSize: z.string().min(1).max(50),
  fullBatchMultiplier: z.number().int().positive().max(1000).optional(),
  // sourceMode: renamed from dryMixSourceMode — generic, no pancake-domain identifier // grep-allow: pancake, dry-mix, drymix
  sourceMode: z.string().min(1).max(50).optional(),
  // allowSameAcrossBatches: renamed from allowSameFlavorAcrossBatches — generic
  allowSameAcrossBatches: z.boolean().optional(),
  // REVIEWS-3 LOW MEDIUM #5: defense-in-depth against thousands-of-keys AI extraction.
  // Keys bounded 1..100 chars, max 100 entries, optional (omit-when-empty convention).
  // z.record() has no .max() in Zod v4 — entry-count bound enforced via .refine().
  selections: z
    .record(z.string().min(1).max(100), z.unknown())
    .refine((r) => Object.keys(r).length <= 100, {
      message: "selections must not exceed 100 entries",
    })
    .optional(),
});
